import type { Appointment } from '@/types';

export const appointments: Appointment[] = [
  {
    id: 'RDV-2026-0301',
    customerName: 'Ayşe Yılmaz',
    phone: '0532 456 78 90',
    service: 'Villa Detaylı Temizlik',
    location: 'Beykoz / İstanbul',
    address: 'Beykoz, Kavacık Mah. No:12',
    date: '26 Ağustos 2026',
    startTime: '10:00',
    duration: '5 saat',
    team: 'A Ekibi',
    status: 'Planlandı',
    quoteAmount: 18500,
    quoteId: 'VP-2026-0048',
    customerNote: 'Anahtar komşuda, 10:00 itibarıyla teslim alınabilir.',
    internalNote: 'Camlar ve zemin cilası dahil, yanında yeterli ekipman götür.',
  },
  {
    id: 'RDV-2026-0302',
    customerName: 'Elif Doğan',
    phone: '0537 450 88 26',
    service: 'Villa Temizliği',
    location: 'Üsküdar / İstanbul',
    address: 'Üsküdar, Kuzguncuk No:7',
    date: '26 Ağustos 2026',
    startTime: '13:30',
    duration: '4 saat',
    team: 'B Ekibi',
    status: 'Planlandı',
    quoteAmount: 15000,
    quoteId: 'VP-2026-0046',
    customerNote: 'Düzenli müşteri, kapı açık olacak.',
    internalNote: '',
  },
  {
    id: 'RDV-2026-0303',
    customerName: 'Mehmet Demir',
    phone: '0533 214 55 87',
    service: 'İnşaat Sonrası Temizlik',
    location: 'Silivri / İstanbul',
    address: 'Silivri, Selimpaşa Cad. No:88',
    date: '26 Ağustos 2026',
    startTime: '16:00',
    duration: '6 saat',
    team: 'A Ekibi',
    status: 'Planlandı',
    quoteAmount: 0,
    quoteId: '',
    customerNote: 'İnşaat sonrası ilk temizlik, ağır kir olabilir.',
    internalNote: 'Teklif henüz hazırlanmadı, iş öncesi teklifi netleştir.',
  },
  {
    id: 'RDV-2026-0304',
    customerName: 'Ahmet Çelik',
    phone: '0535 321 90 44',
    service: 'Plaza / Ofis Temizliği',
    location: 'Kadıköy / İstanbul',
    address: 'Kadıköy, Moda Cad. No:21',
    date: '27 Ağustos 2026',
    startTime: '09:00',
    duration: '3 saat',
    team: 'C Ekibi',
    status: 'Planlandı',
    quoteAmount: 8500,
    quoteId: 'VP-2026-0043',
    customerNote: 'Ofis mesai öncesi temizlenmeli.',
    internalNote: '',
  },
  {
    id: 'RDV-2026-0305',
    customerName: 'Fatma Şahin',
    phone: '0539 876 40 93',
    service: 'Yazlık Ev Temizliği',
    location: 'Büyükçekmece / İstanbul',
    address: 'Büyükçekmece, Mimar Sinan No:2',
    date: '27 Ağustos 2026',
    startTime: '14:00',
    duration: '4 saat',
    team: 'B Ekibi',
    status: 'Planlandı',
    quoteAmount: 9600,
    quoteId: 'VP-2026-0044',
    customerNote: 'Yazlık açılış temizliği.',
    internalNote: 'Revizyon talebi var, tutarı güncelle.',
  },
  {
    id: 'RDV-2026-0306',
    customerName: 'Emre Korkmaz',
    phone: '0544 567 29 18',
    service: 'Plaza / Ofis Temizliği',
    location: 'Şişli / İstanbul',
    address: 'Şişli, Nişantaşı No:9',
    date: '28 Ağustos 2026',
    startTime: '10:30',
    duration: '3 saat',
    team: 'C Ekibi',
    status: 'Planlandı',
    quoteAmount: 0,
    quoteId: '',
    customerNote: 'İlk temizlik denemesi.',
    internalNote: '',
  },
];